<template>
  <div>
    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">Postcode</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <a-input type="text" :name="postalCodeInput" v-model="postalCodeValue"
                 v-bind:style="{ 'border-color': validPostalCode ? null : 'red'}"
                 @input="onPostalCodeInput" v-on:blur="searchAndValidatePostalCode"/>
        <small v-if="!validPostalCode" style="font-weight: bold;color: #ff0000a6;">Postcode voldoet niet aan
          0000AA formaat</small>
      </div>
    </div>
    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">Huisnummer</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <a-input type="text" :name="houseNumberInput" v-model="houseNumberValue"
                 @input="onHouseNumberInput" v-on:blur="searchAddressTimeout"/>
      </div>
    </div>
    <div class="form-group" v-if="houseNumberAdditionInput !== null">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">Toevoeging</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <a-input type="text" :name="houseNumberAdditionInput" v-model="houseNumberAdditionValue"
                 @input="onHouseNumberAdditionInput" v-on:blur="searchAddressTimeout"/>
      </div>
    </div>
    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">Straat</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <a-input type="text" :name="streetNameInput" v-model="streetNameValue" :disabled="loading"/>
      </div>
    </div>
    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">Plaats</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <a-input type="text" :name="cityInput" v-model="cityValue" :disabled="loading"/>
      </div>
    </div>
    <div class="form-group" v-if="foreignAddressCheckbox">
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <a-checkbox @change="isForeignAddress">
          <b>Buitenlands adres invoeren</b>
        </a-checkbox>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
// import countryApi from '~/api/country';
import addressApi from '~/api/address';
import store from '../store';

export default {
  name: "InputSearchComponent",
  inheritAttrs: false,
  props: {
    postalCodeInput: {
      type: String,
      required: true
    },
    houseNumberInput: {
      type: String,
      required: true
    },
    houseNumberAdditionInput: {
      type: String,
      default: null
    },
    streetNameInput: {
      type: String,
      required: true
    },
    cityInput: {
      type: String,
      required: true
    },
    postalCode: {
      type: String,
      default: ''
    },
    houseNumber: {
      type: String,
      default: ''
    },
    houseNumberAddition: {
      type: String,
      default: ''
    },
    streetName: {
      type: String,
      default: ''
    },
    city: {
      type: String,
      default: ''
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    disableAutoComplete: {
      type: Boolean,
      default: false
    },
    foreignAddressCheckbox: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data() {
    return {
      postalCodeValue: this.postalCode.replace(/[ ]+/, ''),
      houseNumberValue: this.houseNumber,
      houseNumberAdditionValue: this.houseNumberAddition,
      streetNameValue: this.streetName,
      cityValue: this.city,
      timeout: null,
      loading: false,
      validPostalCode: true,
      isForeignAddressChecked: this.disableAutoComplete,
    }
  },
  created() {
    const STORE_KEY = '$_attachable';
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }

    if (this.postalCode.length > 0) {
      this.validatePostalCode();
    }
  },
  computed: {
    ...mapGetters({
      breadcrumbs: '$_attachable/breadcrumbs',
    })
  },
  methods: {
    isForeignAddress(e) {
      if (e.target.checked) {
        this.isForeignAddressChecked = true;
      } else {
        this.isForeignAddressChecked = false;
      }
      this.searchAndValidatePostalCode();
    },
    searchAndValidatePostalCode() {
      this.validatePostalCode();
      this.searchAddressTimeout();
    },
    validatePostalCode() {
      if (this.isForeignAddressChecked === false) {
        if (this.postalCodeValue.length > 0) {
          this.validPostalCode = (this.postalCodeValue.match(/^\d{4}[a-zA-Z]{2}$/) !== null)
        } else {
          this.validPostalCode = true;
        }
      } else {
        this.validPostalCode = true;        //TODO: This should be validated by foreign postal code checker
      }
    },
    onPostalCodeInput(event) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.searchAddress, 500);
      this.postalCodeValue = event.target.value.replace(/[ +]/, '');
    },
    onHouseNumberInput(event) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.searchAddress, 500);
    },
    onHouseNumberAdditionInput(event) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.searchAddress, 500);
    },
    searchAddressTimeout() {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.searchAddress, 500);
    },
    searchAddress() {
      if (this.isForeignAddressChecked === false) {
        if (
                this.postalCodeValue.length === 0
                || this.houseNumberValue.length === 0
        ) {
          return;
        }

        this.loading = true;

        let houseLetter = this.houseNumberAdditionValue ? this.houseNumberAdditionValue.match(/([a-zA-ZÀ-ÿ ß]+)(?=\d*\d)/) : null;
        let houseAddition = this.houseNumberAdditionValue ? this.houseNumberAdditionValue.match(/[0-9]+([a-zA-ZÀ-ÿ ß]+)?/) :  null;

        if(houseLetter) {
          houseLetter = houseLetter[0]
        }

        if(houseAddition) {
          houseAddition = houseAddition[0]
        }

        addressApi.search(
            this.postalCodeValue,
            this.houseNumberValue,
            houseLetter,
            houseAddition,
        ).then((response) => {
          this.loading = false;
          this.streetNameValue = response.data.street;
          this.cityValue = response.data.city;
        }).catch((response) => {
          this.loading = false;
          this.streetNameValue = '';
          this.cityValue = '';
          if (houseLetter || (houseAddition && houseAddition.match(/[a-zA-ZÀ-ÿ ß]/))) {
            alert('Er is geen adres gevonden. Controleer hoe de adres toevoeging. Voer deze in als "Huisletter Toevoeging":');
          }
        });
      }
    },
  },
  mounted() {
  }
}
</script>
